import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=25911f09&"
import script from "./BusinessDetails.vue?vue&type=script&lang=js&"
export * from "./BusinessDetails.vue?vue&type=script&lang=js&"
import style0 from "./BusinessDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports